import React from 'react'

const NotAllowed = () => {
    return (
        <>
            <h2 className="text-center">VisualSense is a private web application that allow you to produce complex surveys.
            <br /><br />
            It seems that you don't have the permissions to use the application,<br /> please contact support at xyz@support.io to get access.
            </h2>
        </>
    )
}

export default NotAllowed
